import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ColumnOptionsDialog from '../../../uiComponents/ColumnOptionsDialog';

// At least one HGVS column must remain selected for the variants table.
const requiredHgvsColumnIds = ['chromosomalHGVS', 'transcriptReferenceHGVS'];
const requiredHgvsMessage =
  'Select either Chromosomal HGVS or Transcript Reference HGVS before saving.';

// Adapter for the program summary variants table. Normalizes the flat available
// fields into the option shape expected by the shared ColumnOptionsDialog and
// enforces the required-HGVS-column rule.
const SelectFieldsDialog = ({ open, onClose, fields, availableFields, defaultFields, onSave }) => {
  const resolvedDefaults = useMemo(
    () => defaultFields || availableFields || [],
    [defaultFields, availableFields]
  );

  const activeFields = useMemo(
    () => (fields && fields.length > 0 ? fields : resolvedDefaults),
    [fields, resolvedDefaults]
  );

  const options = useMemo(
    () =>
      (availableFields || []).map((field) => ({
        id: field.id,
        label: field.label,
        field: { ...field, enabled: true },
      })),
    [availableFields]
  );

  return (
    <ColumnOptionsDialog
      open={open}
      onClose={onClose}
      fields={activeFields}
      options={options}
      onSave={onSave}
      minFields={1}
      requireOneOf={requiredHgvsColumnIds}
      requireOneOfMessage={requiredHgvsMessage}
      showRestoreDefault
      defaultFields={resolvedDefaults}
    />
  );
};

SelectFieldsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      enabled: PropTypes.bool,
    })
  ),
  availableFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      enabled: PropTypes.bool,
    })
  ),
  defaultFields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      enabled: PropTypes.bool,
    })
  ),
  onSave: PropTypes.func,
};

export default SelectFieldsDialog;
